/*
 * @Author:
 * @Date: 2023-03-02 20:49:56
 * @LastEditors: Yuan Wei Lin
 * @LastEditTime: 2023-12-13 17:40:40
 * @Description:
 */
import { createApp } from "vue";
import App from "./App.vue";
const app = createApp(App);
import router from "./router";
import store from "./store";
app.use(store).use(router);

// import "../node_modules/lib-flexible/flexible";

// 引入css清除默认样式文件
import "./assets/css/reset.css";

// 引入公共样式文件
import "./assets/css/public.less";

// 引入element
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
app.use(ElementPlus);

// // 全局注册icon
// import * as ElementPlusIconsVue from "@element-plus/icons-vue";
// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//   app.component(key, component);
// }

// 联系我们
import ccontactus from "@/components/contactUs.vue";
// eslint-disable-next-line vue/multi-word-component-names
app.component("Contactus", ccontactus);

//全局引入utils
import utils from "./utils/index";
app.config.globalProperties.$utils = utils;

//全局引入axios
import axios from "@/api/axios";
app.config.globalProperties.$axios = axios;

app.mount("#app");
